import { nationalTopic as nationalTopicService } from '../../services';

export const ActionTypes = {
  SET_NATIONAL_TOPICS: 'SET_NATIONAL_TOPICS',
  SET_NAV_REFERRER: 'SET_NAV_REFERRER',
  API_ERROR: 'API_ERROR',
};

/**
 * @description action creator for getting all national topics
 */
export const getAllNationalTopics = () => {
  return async (dispatch) => {
    try {
      const data = await nationalTopicService.fetchAll();
      dispatch({ type: ActionTypes.SET_NATIONAL_TOPICS, payload: data });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_NATIONAL_TOPICS,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for setting all new national topics
 * @param {Object} topics object of new topics to set
 */
export const setNewNationalTopics = (topics) => {
  return async (dispatch) => {
    try {
      await nationalTopicService.setNewNationalTopics(topics);
      const data = await nationalTopicService.fetchAll();
      dispatch({ type: ActionTypes.SET_NATIONAL_TOPICS, payload: data });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_NATIONAL_TOPICS,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for setting navigation referrer
 */
export const setNavReferrer = (link) => {
  return (dispatch) => {
    dispatch({ type: ActionTypes.SET_NAV_REFERRER, payload: link });
  };
};
